// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".uma-react-home-mfe h1,.uma-react-home-mfe h2{font-weight:400 !important}", "",{"version":3,"sources":["webpack://./src/styles/global.scss"],"names":[],"mappings":"AAAA,8CAEE,0BAAA","sourcesContent":[".uma-react-home-mfe h1,\n.uma-react-home-mfe h2 {\n  font-weight: 400 !important; /* important to beat specificity of veneer grouped selector */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
